import { Component, ViewChild, ViewEncapsulation } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { Constants } from "../../constant/constant";
import { LoggingService } from "src/app/logging.service";
import { environment } from "src/environments/environment";

const TREE_DATA: any = [
  {
    name: "Kaleidoscope",
    children: [
      { name: "Delivery Lens", url: "/delivery/projects" },
      { name: "Balanced Scorecard", url: "/balancedscorecard/dashboard" },
      { name: "Risk Net", url: "/riskconvergence" },
      {
        name: "FIn Hub",
        url: "project-finance/finance-hub",
      },
    ],
  },
  {
    name: "Northstar",
    children: [
      { name: "OKR Convergence", url: "/okrconvergence" },
      { name: "BVTI Index", url: "/bvt-index" },
            { name: "GRC Workbench", url: "/incidentracker" },
      { name: "Expert Insights", url: "strategicRelevance/maven" },
    ],
  },
  {
    name: "CoSInE",
    children: [
      { name: "Opportunity Workbench", url: "/program" },
      {
        name: "Deal Central",
        url: "/deal-structure",
      },
      {
        name: "Contracts Intel",
        url: "contracts-intel",
      },

      {
        name: "FinOps Hub",
        url: "finops-hub",
      },
    ],
  },
  {
    name: "Confluence",
    children: [
      {
        name: "Plan Central",
        url: "/confluence/teamplantracker",
        matching_urls: [
          "confluence/plan",
          "confluence/teamplantemplates?readMode=0",
          "confluence/teamplantemplates?ipdb=1",
        ],
      },
      { name: "Tech Map", url: "application-master" },
      {
        name: "Assessments & Surveys",
        url: "strategicRelevance/assessment-central",
        matching_urls: [
          "performanceInsights/survey-central",
          "strategicRelevance/governancect",
        ],
      },
      { name: "Delivery Accelerators", url: "/delivery-accelerator/dashboard" },
    ],
  },
  {
    name: "Prism",
    children: [
      // { name: "Community of Practice", url: "external" },
      { name: "Action Central", url: "/actiontracker" },
      { name: "Parade", url: "parade" },
      {
        name: "Catalog",
        url: "prism/ipdb",
        matching_urls: [
          "toemasterlist",
          "people-competency-matrics",
          "technology-business-management-taxonomy",
          "metrics-master",
          "sowmaster",
          "vendor-master",
          "rate/rate-master",
          "organization-hierarchy",
          "workforce/dashboard",
          "profit-cost-centers",
          "data-source",
          "simple-metric",
          "derived-metric",
        ],
      },
      
      { name: "Airo", url: "airo" },
    ],
  },
];

const VENDOR_MENU_DATA: any = [
  {
    name: "Kaleidoscope",
    children: [
      { name: "Balanced Scorecard", url: "/balancedscorecard/dashboard" },
      { name: "Risk Net", url: "/riskconvergence" },
      { name: "Delivery Lens", url: "/delivery/projects" },
      { name: "Pulse", url: "performanceInsights/pulse" },
    ],
  },
  {
    name: "CoSInE",
    children: [
      { name: "Opportunity Workbench", url: "/program" },
      {
        name: "Idea Workbench",
        url: "/challenge-workbench/challenge-statements",
        matching_urls: [
          "/challenge-workbench/challenge-statements",
          "ideapitch",
        ],
      },
    ],
  },
  // {
  //   name: "Confluence",
  //   children: [{ name: "Community of Practice", url: "external" }],
  // },
  // {
  //   name: "Prism",
  //   children: [
  //     { name: "Project Lens", url: "/delivery/projects" },
  //     { name: "GRC Workbench", url: "/incidentracker" },
  //   ],
  // },
];

@Component({
  selector: "app-side-menu",
  templateUrl: "./side-menu.component.html",
  styleUrls: ["./side-menu.component.scss"],
  encapsulation: ViewEncapsulation.Emulated,
})
export class SideMenuComponent {
  mainmenu: any;
  @ViewChild("stepper") stepper: any;
  user: any;

  constructor(
    private readonly route: Router,
    private readonly activeroute: ActivatedRoute,
    private readonly loggingService: LoggingService
  ) {
    this.user = JSON.parse(localStorage.getItem("permission") ?? "{}");
    this.mainmenu = this.user?.is_vendor ? VENDOR_MENU_DATA : TREE_DATA;
  }

  ngOnInit(): void {
    this.activeroute.params.subscribe(() => {
      this.stepSeleted();
    });
  }

  isUrlMatch(element: any): boolean {
    const currentUrl = this.route?.url ?? "";

    if (element.url && currentUrl.includes(element.url)) {
      return true;
    }

    if (Array.isArray(element.matching_urls)) {
      return element.matching_urls.some((m: string) => currentUrl.includes(m));
    }

    return false;
  }

  stepSeleted() {
    setTimeout(() => {
      for (const i in this.mainmenu) {
        if (this.mainmenu.hasOwnProperty(i)) {
          const children = this.mainmenu[i]?.children || [];
          children.forEach((element: any) => {
            if (this.isRouteMatch("survey-details", element.url, "hubble", i)) {
              return;
            }
            if (
              this.isRouteMatch(
                "challenge-workbench",
                element.url,
                "challenge-workbench",
                i
              )
            ) {
              return;
            }
            if (
              this.isRouteMatch(
                "delivery-accelerator",
                element.url,
                "delivery-accelerator",
                i
              )
            ) {
              return;
            }
            if (
              this.isRouteMatch(
                "confluence",
                element.url,
                "confluence/teamplantracker",
                i,
                ["confluence/teamplantemplates", "confluence/plan"]
              )
            ) {
              return;
            }

            if (this.isUrlMatch(element)) {
              this.stepper.selectedIndex = i;
            }
          });
        }
      }
    }, 100);
  }

  isRouteMatch(
    routeKey: string,
    elementUrl: string,
    matchUrl: string,
    index: any,
    additionalUrls: string[] = []
  ) {
    if (
      this.route?.url?.includes(routeKey) &&
      (elementUrl.includes(matchUrl) ||
        additionalUrls.some((url) => elementUrl.includes(url)))
    ) {
      this.stepper.selectedIndex = index;
      return true;
    }
    return false;
  }

  hasChild = (_: number, node: any) =>
    !!node.children && node.children.length > 0;

  navigateUrl(url: any) {
    if (url && url.indexOf("external") > -1) {
      this.navigateToSP();
    } else if (url.indexOf("airo") > -1) {
      this.navigateToAiro();
    } else if (url) {
      this.route.navigateByUrl(url);
    } else {
      this.loggingService.warn("Unexpected value");
    }
  }

  openBlank(url: any) {
    window.open(url, "_blank");
  }

  navigateToSP() {
    window.open(Constants.SHAREPOINT_URL, "_blank");
  }

  navigateToAiro() {
    this.openBlank(environment.airoFrontendURL);
  }
}
